export const localization = {
  en: {
    medication: 'Medications',
    immunization: 'Immunizations',
    print: 'Print',
    patientName: 'Patient Name:',
    dob: 'DOB:',
    page: 'Page',
    of: 'of',
    immunization_record: 'Immunization record for',
    medication_record: 'Medication record for',
    medication_disclaimer:
      'This medication record was downloaded from the MyCHOC patient portal. Please note: not all medication records will be viewable or available. Any medications received at a non-CHOC location may not be reflected in this report. If you believe any information is incorrect, please contact your primary care office or CHOC Health Information Management at choclink@choc.org.',
    immunization_disclaimer:
      'This immunization record was downloaded from the MyCHOC patient portal. Please note: not all immunization records will be viewable or available. Any immunizations received at a non-CHOC location may not be reflected in this report. If you believe any information is incorrect, please contact your primary care office or CHOC Health Information Management at choclink@choc.org.'
  },
  es: {
    medication: 'Medicación',
    immunization: 'Inmunización',
    print: 'Imprimir',
    patientName: 'Nombre del paciente:',
    dob: 'Fecha de nacimiento:',
    page: 'Página',
    of: 'de',
    immunization_record: 'Registro de inmunización para',
    medication_record: 'Registro de medicación para',
    medication_disclaimer:
      'Este registro de medicación fue descargado desde el portal del paciente MyCHOC. Por favor, ten en cuenta: no todos los registros de medicación serán visibles o estarán disponibles. Los medicamentos recibidos en un lugar que no sea CHOC es posible que no se reflejen en este informe. Si crees que alguna información es incorrecta, por favor, contacta a tu consultorio de atención primaria o a CHOC Health Information Management en choclink@choc.org.',
    immunization_disclaimer:
      'Este registro de vacunación fue descargado desde el portal del paciente MyCHOC. Por favor, ten en cuenta: no todos los registros de vacunación serán visibles o estarán disponibles. Las vacunas recibidas en un lugar que no sea CHOC es posible que no se reflejen en este informe. Si crees que alguna información es incorrecta, por favor, contacta a tu consultorio de atención primaria o a CHOC Health Information Management en choclink@choc.org.'
  },
  /* eslint-disable no-secrets/no-secrets */
  keyMapping: {
    medication: 'UFD_Medications_Text',
    immunization: 'UFD_Immunizations_Text',
    print: 'UFD_Print_Button',
    patientName: 'UFD_Print_Patient_Name',
    dob: 'UFD_Print_DOB',
    page: 'UFD_Print_Page_Text',
    of: 'UFD_Print_Of_Text',
    immunization_record: 'UFD_Print_Immu_Record',
    medication_record: 'UFD_Print_Medi_Record',
    medication_disclaimer: 'UFD_Medication_Disclaimer',
    immunization_disclaimer: 'UFD_Immunization_Disclaimer'
  }
  /* eslint-enable no-secrets/no-secrets */
}
